import '../css/tailwind.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import VueToasted from '@hoppscotch/vue-toasted';
import httpPlugin from '@kate/plugins/http';
import loggerPlugin from '@kate/plugins/logger';
import App from './app.vue';
import router from './router';
import useGlobalStore from '@stores/global';
import PermissionsHandler from '@plugins/permissions-handler';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(loggerPlugin, {
  router,
  getStateInfo: () => ({
    appName: 'applicant_portal_staff',
    userId: useGlobalStore(pinia).userId,
  }),
});
app.use(httpPlugin);
app.use(VueToasted, { iconPack: 'fontawesome', router });
app.use(PermissionsHandler);

router.isReady().then(() => app.mount('#app'));
